import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const QRFeatureDemo = () => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
  {
    id: 0,
    title: "Escanea el Código QR",
    description: "Usa tu smartphone para escanear el código QR único de cada negocio registrado en BIZZNET",
    icon: "QrCode",
    image: "https://images.unsplash.com/photo-1719543131874-f230a7088051",
    imageAlt: "Close-up of hands holding smartphone scanning QR code on business counter with modern retail environment in background"
  },
  {
    id: 1,
    title: "Accede al Descuento",
    description: "El sistema verifica tu membresía activa y te muestra el descuento exclusivo disponible para tu nivel",
    icon: "BadgePercent",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bcedfce1-1766844615345.png",
    imageAlt: "Smartphone screen displaying discount percentage notification with colorful interface and shopping cart icon in bright retail setting"
  },
  {
    id: 2,
    title: "Disfruta tu Ahorro",
    description: "Presenta tu código de descuento al comercio y ahorra en tu compra. El negocio registra tu visita automáticamente",
    icon: "Sparkles",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1884191ad-1766471451247.png",
    imageAlt: "Happy customer showing phone screen to smiling cashier at modern checkout counter with shopping bags visible"
  }];


  return (
    <section className="py-20 px-6 bg-muted">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4">
            Beneficios para Usuarios
          </h2>
          <h3 className="text-2xl md:text-3xl font-semibold text-primary mb-4">
            Cómo Funciona el Sistema QR
          </h3>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Obtén descuentos exclusivos en tres simples pasos
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            {steps?.map((step, index) =>
            <div
              key={step?.id}
              onClick={() => setActiveStep(index)}
              className={`cursor-pointer p-6 rounded-xl transition-all ${
              activeStep === index ?
              'bg-primary text-primary-foreground shadow-lg scale-105' :
              'bg-card hover:bg-muted'}`
              }>

                <div className="flex items-start gap-4">
                  <div className={`flex items-center justify-center w-12 h-12 rounded-lg flex-shrink-0 ${
                activeStep === index ? 'bg-white/20' : 'bg-primary/10'}`
                }>
                    <Icon
                    name={step?.icon}
                    size={24}
                    color={activeStep === index ? '#FFFFFF' : 'var(--color-primary)'} />

                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <span className={`text-sm font-bold ${
                    activeStep === index ? 'text-white' : 'text-primary'}`
                    }>
                        Paso {index + 1}
                      </span>
                      <h3 className="text-xl font-bold">{step?.title}</h3>
                    </div>
                    <p className={`text-sm ${
                  activeStep === index ? 'text-white/90' : 'text-muted-foreground'}`
                  }>
                      {step?.description}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="relative">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <Image
                src={steps?.[activeStep]?.image}
                alt={steps?.[activeStep]?.imageAlt}
                className="w-full h-full object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="flex items-center gap-3 bg-white/95 backdrop-blur-sm rounded-lg p-4">
                  <Icon name={steps?.[activeStep]?.icon} size={24} color="var(--color-primary)" />
                  <span className="font-bold text-foreground">{steps?.[activeStep]?.title}</span>
                </div>
              </div>
            </div>

            <div className="flex justify-center gap-2 mt-6">
              {steps?.map((_, index) =>
              <button
                key={index}
                onClick={() => setActiveStep(index)}
                className={`w-3 h-3 rounded-full transition-all ${
                activeStep === index ? 'bg-primary w-8' : 'bg-border'}`
                }
                aria-label={`Go to step ${index + 1}`} />

              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default QRFeatureDemo;